export default __webpack_public_path__ + "static/Montserrat-BoldItalic-a32ae5d9b605d950167e7b71fab7b995.ttf";